// extracted by mini-css-extract-plugin
export var contentBody = "_71-9";
export var headerImage = "_71-2";
export var imageButton = "_71-7";
export var imageButtonIcon = "_71-8";
export var imageHeader = "_71-4";
export var imageHeaderText = "_71-5";
export var imageOverlay = "_71-3";
export var imageTitle = "_71-6";
export var imageWrapper = "_71-1";
export var taskList = "_71-a";
export var widget = "_71-0";